import { useMemo } from "react"
import PropTypes from "prop-types"
import { Tab as MuiTab } from "@mui/material"
import NewFeature from "modules/new-feature"
import "./style.scss"

function Tab({ label, tooltip, newFeature, ...props }) {
  const renderedLabel = useMemo(() => {
    const wrapNewFeature = (node) => newFeature ? <NewFeature id={newFeature}>{node}</NewFeature> : node
    return (
      <span className="components_tab-tooltip-label">
        {tooltip ? wrapNewFeature((
          <>
            {tooltip}
            {label}
          </>
        )) : wrapNewFeature(label)}
      </span>
    )
  }, [label, tooltip, newFeature])
  return <MuiTab {...props} className="components_tab" label={renderedLabel} />
}

Tab.propTypes = {
  label: PropTypes.string.isRequired,
  tooltip: PropTypes.element,
  newFeature: PropTypes.string,
}

export default Tab
